













import Vue from 'vue';

  export default Vue.extend({
    name: 'Login',
    data: () => ({
      usr: '',
      pwd: ''
    }),
    methods: {
      raiseLogin() {
        this.$emit('login', this.usr, this.pwd)
        this.pwd = '';
      }
    },
});
